exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.dof-tag-group[data-v-6ae63b47] {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n}\n", "", {"version":3,"sources":["/Users/wuhm45/Documents/code/weex组件库/dolphin-weex-ui/packages/dof-tag-group/index.vue?3253f7ba"],"names":[],"mappings":";AAeA;EACA,6BAAA;EAAA,8BAAA;EAAA,+BAAA;UAAA,uBAAA;CACA","file":"index.vue","sourcesContent":["<template>\n  <div class=\"dof-tag-group\">\n    <slot></slot>\n  </div>\n</template>\n\n<script>\nimport { mixSelectableParent } from '../utils/mix-selectable-parent.js'\n\nexport default {\n  mixins: [mixSelectableParent('dof-tag-group')]\n}\n</script>\n\n<style scoped>\n.dof-tag-group {\n  flex-direction: column;\n}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ae63b47","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-tag-group/index.vue
// module id = 212
// module chunks = 0 1